
import Injection = EECore.Injection;
import { WidgetResources } from "../../resources/widget";
import CorporateSearchService from "../../services/corporateSearch/corporateSearchService";
import CorporateSearchModel from "../../services/entities/corporateSearch/corporateSearchModel";
import Model from "../models/corporateSearch/corporateSearchModel";
import Cookie from "../../../../Core/src/lib/cookie";

@Injection.injectableClass("EEWidget.CorporateSearch")
export default class CorporateSearch implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("EEWidget.CorporateSearch", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("EEWidget.CorporateSearch", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("EEWidget.CorporateSearch", "CorporateSearchService")
  private corporateSearchService: CorporateSearchService;

  @Injection.injectableProperty("EEWidget.CorporateSearch", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("EEWidget.CorporateSearch", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("EEWidget.CorporateSearch", EECore.Registrations.COOKIE)
  private cookie: Cookie;

  @Injection.injectableProperty("EEWidget.CorporateSearch", EECore.Registrations.URL_HELPER)
  private urlHelper: EECore.Helpers.UrlHelper;

  constructor(templateFactory: EECore.UI.TemplateFactory, corporateSearchService: CorporateSearchService, webComponentFactory: EECore.UI.WebComponentFactory,
    document: Document, resources: WidgetResources, cookie: Cookie, urlHelper: EECore.Helpers.UrlHelper) {
    this.templateFactory = templateFactory;
    this.corporateSearchService = corporateSearchService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
    this.resources = resources;
    this.cookie = cookie;
    this.urlHelper = urlHelper;
  }

  load(): EECore.Promise<Element, string> | Element {
    const clientNo = this.cookie.getValue("wemwpn45-clientNo");
    const companyCode = this.cookie.getValue("wemwpn45-companyCode");

    if (!companyCode || !clientNo) {
      const component = this.renderTemplate(null);

      return component;
    }

    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.corporateSearchService.getContracts(clientNo, companyCode).then((corporateSearchModel: CorporateSearchModel) => {
        const template = this.renderTemplate(corporateSearchModel);
        this.setupNewSearchButton(template);

        resolve(template);
      }).catch(() => {
        reject("Could not get the contracts.");
      });
    });
  }

  protected renderTemplate(corporateSearch: CorporateSearchModel): Element {
    const model = new Model();
    model.title = this.resources.contract.title;
    model.subTitle = this.resources.contract.subTitle;
    model.newSearch = this.resources.contract.newSearch;

    if (!corporateSearch || corporateSearch.contracts.length === 0) {
      model.searchLink = this.urlHelper.processUrl("/WEMWPN45");
      return this.templateFactory.getTemplate("CorporateSearchEmpty", model);
    }

    model.fullName = corporateSearch.fullName;

    return this.templateFactory.getTemplate("CorporateSearch", model);
  }

  private setupNewSearchButton(corporateSearchElement: Element) {
    const element = corporateSearchElement.querySelector("#btnNewSearch");
    if (element === undefined || element === null) return;
    element.addEventListener("click", () => {
      location.href = this.urlHelper.processUrl("/WEMWPN45");
    });
  }
}